import { useEffect, useState } from "react";
import { Crown, Check } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Progress } from "@/components/ui/progress";

const COLORS = { Bronze: "#CD7F32", Silver: "#C0C7D1", Gold: "#FFB800", Platinum: "#7DD3FC", Diamond: "#C4B5FD" };

export default function VipPage() {
  const { user } = useApp();
  const [tiers, setTiers] = useState([]);
  useEffect(() => { api.get("/vip/tiers").then((r) => setTiers(r.data)); }, []);
  const v = user?.vip;
  const cur = tiers.find((t) => t.name === v?.tier);
  const pct = v?.next_min ? ((v.points - (cur?.min || 0)) / (v.next_min - (cur?.min || 0))) * 100 : 100;

  return (
    <main className="relative z-10 max-w-5xl mx-auto px-4 py-8" data-testid="vip-page">
      <div className="rounded-3xl border border-white/10 bg-gradient-to-br from-[#1F2633] to-[#0B0E14] p-6 sm:p-10">
        <div className="flex items-center gap-3"><Crown size={32} color={COLORS[v?.tier]} /><h1 className="font-display text-4xl sm:text-5xl font-black" data-testid="vip-current-tier">{v?.tier} VIP</h1></div>
        <p className="mt-2 text-gray-400">{v?.points.toLocaleString()} VIP points · +{v?.bonus}% bonus GC on every purchase</p>
        <div className="mt-6">
          <Progress value={pct} className="h-3 bg-white/10" data-testid="vip-progress" />
          <div className="mt-2 text-sm text-gray-400">{v?.next_tier ? `${(v.next_min - v.points).toLocaleString()} points to ${v.next_tier}` : "Top tier reached"}</div>
        </div>
        <p className="mt-4 text-xs text-gray-500">Earn 100 points per $1 spent and 1 point per SC played.</p>
      </div>
      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {tiers.map((t) => {
          const reached = v && v.points >= t.min;
          return (
            <div key={t.name} data-testid={`vip-tier-${t.name.toLowerCase()}`} className={`rounded-2xl border p-5 bg-[#151A22] ${t.name === v?.tier ? "border-[#FFB800]/60" : "border-white/5"}`}>
              <Crown color={COLORS[t.name]} />
              <div className="mt-3 font-display text-xl font-black">{t.name}</div>
              <div className="text-xs text-gray-500">{t.min.toLocaleString()}+ pts</div>
              <div className="mt-3 text-sm">+{t.bonus}% purchase bonus</div>
              {reached && <div className="mt-3 flex items-center gap-1 text-xs sc-text font-bold"><Check size={14} />Unlocked</div>}
            </div>
          );
        })}
      </div>
    </main>
  );
}
